import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component';
import { TopicComponent } from './topic/topic.component';
import {TeacherGuard} from '../App/teacher-guard.service';
import {TExercisesComponent} from './t-exercises/t-exercises.component';
import {TAllExercisesComponent} from './t-all-exercises/t-all-exercises.component';
import {ClairvoyantComponent} from './clairvoyant/clairvoyant.component';
import {ClairvoyantTwoPlayerComponent} from './clairvoyant-two-player/clairvoyant-two-player.component';
import {ClairvoyantColorTwoPlayerComponent} from './clairvoyant-color-two-player/clairvoyant-color-two-player.component';
import {ClairvoyantColorBitsComponent} from './clairvoyant-color-bits/clairvoyant-color-bits.component';
import {ClairvoyantChangeTwoPlayerComponent} from './clairvoyant-change-two-player/clairvoyant-change-two-player.component';
import {DefectEncodingComponent} from './defect-encoding/defect-encoding.component';
import {GoodOrBadEncodingComponent} from './good-or-bad-encoding/good-or-bad-encoding.component';


const dataRepresentationRoutes: Routes = [
  { path: 'cardtricks', component: TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
      { path: 'clairvoyant/:id', component: ClairvoyantComponent},
      { path: 'clairvoyant-two-player/:id', component: ClairvoyantTwoPlayerComponent},
      { path: 'clairvoyant-color-two-player/:id', component: ClairvoyantColorTwoPlayerComponent},
      { path: 'clairvoyant-color-bit/:id', component: ClairvoyantColorBitsComponent},
      { path: 'clairvoyant-change-two-player/:id', component: ClairvoyantChangeTwoPlayerComponent},
      { path: 'defect-encodings/:id', component: DefectEncodingComponent},
      { path: 'good-or-bad-encodings/:id', component: GoodOrBadEncodingComponent}
    ] },
  {path: 'teacher/cardtricks', canActivate: [TeacherGuard], canActivateChild: [TeacherGuard], component: TopicComponent,
    children : [
      { path: '', component: TExercisesComponent, pathMatch: 'full'},
      { path: 'allExercisesTeacher', component: TAllExercisesComponent},
    ] }
];

@NgModule({
  imports: [
    RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
